import dateFnsFormat from 'date-fns/format';
import dateFnsDistanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import { getEnv, Env } from '@dcl/ui-env';
import { getCurrentLocale } from '../modules/translation/utils';
export function isMobile() {
    // WARN: Super naive mobile device check.
    // we're using it on low-stake checks, where failing to detect some browsers is not a big deal.
    // If you need more specificity you may want to change this implementation.
    const navigator = window.navigator;
    return (!!navigator &&
        (/Mobi/i.test(navigator.userAgent) || /Android/i.test(navigator.userAgent)));
}
export function insertScript({ type = 'text/javascript', async = true, ...props }) {
    const script = document.createElement('script');
    Object.assign(script, { type, async: async, ...props }); // WARN: babel breaks on `{ async }`
    document.body.appendChild(script);
    return script;
}
export function toObjectById(values, currentValues = {}) {
    return toObjectByKey(values, currentValues, 'id');
}
export function toObjectByKey(values, currentValues = {}, key) {
    return values.reduce((obj, value) => {
        obj[value[key]] = value;
        return obj;
    }, { ...currentValues });
}
export function distanceInWordsToNow(date, addSuffix = true) {
    return dateFnsDistanceInWordsToNow(date, {
        addSuffix,
        locale: getCurrentLocale()
    });
}
export function formatDate(date, format = 'MMMM Do, YYYY') {
    return dateFnsFormat(date, format, {
        locale: getCurrentLocale()
    });
}
export function formatDateTime(date, format = 'MMMM Do, YYYY - hh:mm aa') {
    return dateFnsFormat(date, format, {
        locale: getCurrentLocale()
    });
}
export function formatNumber(amount = 0, digits = 2) {
    return parseFloat((+amount).toFixed(digits)).toLocaleString();
}
export function getBaseUrl() {
    const env = getEnv();
    if (env === Env.DEVELOPMENT) {
        return 'https://decentraland.zone';
    }
    else if (env === Env.STAGING) {
        return 'https://decentraland.today';
    }
    else {
        return 'https://decentraland.org';
    }
}
//# sourceMappingURL=utils.js.map